import PropTypes from 'prop-types';
import React from 'react';
import { connectToStores } from 'fluxible-addons-react';
import DocumentStore from '../../../stores/DocumentStore';
import Spinner from '../../Spinner';
import ContentRenderer from '../../ContentRenderer';

class Tutorial extends React.Component {
  /* eslint-disable react/no-unused-prop-types */
  static propTypes = {
    article: PropTypes.object.isRequired,
    doc: PropTypes.object,
    handleRender: PropTypes.func.isRequired
  };

  render() {
    const { doc } = this.props;

    if (!doc || !doc.html) {
      return <Spinner />;
    }

    return (
      <div className="docs-content quickstart-docs-content">
        <ContentRenderer
          html={doc.html}
          meta={doc.meta}
          afterRender={this.props.handleRender}
        />
      </div>
    );
  }

}

export default connectToStores(
  Tutorial,
  [DocumentStore],
  (context, props) => ({
    doc: context.getStore(DocumentStore).getDocument(props.article.url)
  })
);
